<template>
  <v-card>
    <v-layout
      v-for="presentation in filteredPresentations"
      :key="presentation.codigo"
      @click="handleSelectEvent(presentation)"
    >
      <v-card
        :style="
          presentation.status_venda !== 'esgotada' ? 'cursor: pointer' : ''
        "
        style="width: 100%;"
        class="px-3 py-4"
      >
        <v-layout style="align-items: center;">
          <v-flex>
            <v-layout>
              <span style="font-weight: 600; font-size: 16px;">
                {{
                  $moment(presentation.data)
                    .format('dddd')
                    .replace('-feira', '')
                }}
              </span>
            </v-layout>
            <v-layout>
              <span style="font-weight: 400; font-size: 14px;">
                {{
                  $moment(getFormattedDate(presentation)).format(
                    'DD/MMM - HH:mm'
                  )
                }}
              </span>
            </v-layout>
          </v-flex>

          <v-flex>
            <v-layout class="justify-end">
              <v-chip
                v-if="presentation.status_venda === 'esgotada'"
                outline
                color="#838D9B"
                >Esgotado</v-chip
              >
              <v-icon v-else class="v-icon material-icons theme--light"
                >keyboard_arrow_right</v-icon
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUtmFromRoute } from '../../utils';
export default {
  props: ['filteredPresentations'],
  computed: {
    ...mapGetters(['eventDetails', 'cartProducts']),
  },

  methods: {
    async handleSelectEvent(date) {
      if (date.status_venda !== 'esgotada') {
        this.$store.commit('SET_SALE_UNINITIATED', '');

        let query = {};

        if (this.$route.query.c) query.c = getUtmFromRoute(this.$route);

        this.$router.push({
          params: { id: date.codigo },
          query: query,
        });
        await this.reset(date.codigo);
      }
    },

    async reset(event) {
      this.$store.commit('SET_EVENT_ID', event);

      const checkoutState =
        JSON.parse(localStorage.getItem(`checkoutState`)) || {};
      this.cartProducts.forEach(product => {
        product.forEach(async el => {
          if (el.seats) {
            el.seats.forEach(async sc => {
              await this.$store.dispatch('unbookPurchaseSeats', sc);
            });
          }
        });
      });

      await this.$store.dispatch('fetchEventData');
      await this.$store.dispatch('deleteCheckoutState', event);
      if (
        checkoutState &&
        checkoutState[event] &&
        checkoutState[event].userToken
      )
        await this.$store.dispatch('getClientData');
      await this.$store.dispatch('loadCheckoutState', event);
      await this.$store.dispatch('resetSelection');
      await this.$store.dispatch('setResetPurchase', false);

      return null;
    },

    getFormattedDate(presentation) {
      let splittedDate = `${presentation.data.split(' ')[0]} ${
        presentation.horario_evento
      }:00`;

      return splittedDate;
    },
  },
};
</script>
